import {useTranslation} from "react-i18next";

const DetailsEmpty = () => {
    const { t } = useTranslation()
    return (
        <div className="bg-white overflow-hidden sm:rounded-lg">

            <div className="mx-10 my-10">
                <p>
                    {t('Ensure your notification settings are enabled and your volume is turned on so you know when a new order is recieved.')}
                </p>

                <p className="mt-4">
                    {t('Make sure you keep this page open at all times so you dont miss any new order notifications')}
                </p>
            </div>
        </div>
    )
}

export default DetailsEmpty;
